import { Component, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { AlertController, Events, ModalController } from 'ionic-angular';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { ExportServiceProvider } from '../../providers/export-service/export-service';
import { PriceListTableProvider } from '../../providers/price-list-table/price-list-table';
import { AddDeviceComponent } from '../add-device/add-device';
const DEFAULTVALUE = 0;
@Component({
  selector: 'backupdr-pricing-sheet',
  templateUrl: 'backupdr-pricing-sheet.html'
})
export class BackupdrPricingSheetComponent {
  DateDefault: any = new Date();
  showAddDevice: boolean = false;
  showMonth: boolean = false;
  discountMonths = [{
    "period": "For 3 Months until",
    "value": '3'
  }, {
    "period": "For 6 Months until",
    "value": '6'
  }, {
    "period": "For 9 Months until",
    "value": '9'
  }, {
    "period": "For 12 Months until",
    "value": '12'
  }, {
    "period": "For 18 Months until",
    "value": '18'
  }, {
    "period": "For 24 Months until",
    "value": '24'
  }, {
    "period": "For 36 Months until",
    "value": '36'
  }, {
    "period": "For 48 Months until",
    "value": '48'
  }, {
    "period": "For 60 Months until",
    "value": '60'
  }, {
    "period": "until changed",
    "value": ''
  }];
  months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  newBackupProduct: any;
  SelectedDevices: any;
  headerValues = {
    buttonLabel: [{
      "name": "return",
      "action": 'return'
    }, {
      "name": "price list",
      "action": 'priceList'
    },{
      "name": "preview",
      "action": 'preview'
    }]
  };
  componentRef: any;
  @ViewChild('container', {
    read: ViewContainerRef,
  }) viewContainerRef: ViewContainerRef;
  constructor(public dataService: DataServiceProvider,public modalCtrl: ModalController,public exportService: ExportServiceProvider, public alertCtrl: AlertController, public priceListTableService: PriceListTableProvider, public event: Events, private resolver: ComponentFactoryResolver) {
    this.newBackupProduct = JSON.stringify({
      "backUpProdName": "",
      "quantity": "",
      "price": "",
      "describe": "",
      "monthly": ""
    });
  }

  ngOnInit() {
    this.dataService.goBack = 'BKP';
    this.dataService.sheetName = 'BKP';
    if (localStorage.getItem('BACKUPDRsScreenData')) {
      this.dataService.ProposalTable.backupDrPricingSheet = JSON.parse(localStorage.getItem('BACKUPDRsScreenData'));
      if (this.dataService.ProposalTable.backupDrPricingSheet.backupTools.monthlyPeriod) {
        this.showMonth = true;
      }
    }
    if (localStorage.getItem('MSPForm')) {
      let mspFormValues = JSON.parse(localStorage.getItem('MSPForm'));
      this.dataService.ProposalTable.mspForm.noOfUsers = mspFormValues.noOfUsers != '' ? mspFormValues.noOfUsers : this.dataService.ProposalTable.mspForm.noOfUsers;
      this.dataService.ProposalTable.mspForm.Mailboxes = mspFormValues.Mailboxes != '' ? mspFormValues.Mailboxes : this.dataService.ProposalTable.mspForm.Mailboxes;
      this.dataService.ProposalTable.mspForm.noOfDevices = mspFormValues.noOfDevices != '' ? mspFormValues.noOfDevices : this.dataService.ProposalTable.mspForm.noOfDevices;
      this.dataService.ProposalTable.mspForm.noOfLocations = mspFormValues.noOfLocations != '' ? mspFormValues.noOfLocations : this.dataService.ProposalTable.mspForm.noOfLocations;
      this.DateDefault = mspFormValues.startDate != '' ? new Date(mspFormValues.startDate) : new Date();
    }
    this.addDeviceData();
    var priceListData = JSON.parse(localStorage.getItem('Pricelist'));
    if (priceListData != null) {
      this.priceListTableService.priceList.TotalLabourRegularRate = priceListData.TotalLabourRegularRate;
      this.priceListTableService.priceList.TotalToolsMarkup = priceListData.TotalToolsMarkup;
      let sellVal = 1 + parseInt(priceListData.TotalToolsMarkup.slice(0, -1)) / 100;
      this.priceListTableService.priceList.Backupify.Sell = '$' + (parseFloat(priceListData.Backupify.newCdnCost != '' ? priceListData.Backupify.newCdnCost.slice(1).replace(/  |,/gi,"") : priceListData.Backupify.defCdnCost.slice(1).replace(/  |,/gi,"")) * sellVal).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      priceListData.Intronis.forEach(element => {
        let cdn = (parseFloat(element.newUsd == '' ? element.defUsd.slice(1).replace(/  |,/gi,"") : element.newUsd.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(priceListData.TotalUsExchange.slice(0, -1)) / 100)))
        element.cdn = '$' + cdn.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        element.monthlyPrice = '$' + (cdn * (1 + (parseFloat(element.orMarkup == '' ? priceListData.TotalToolsMarkup.slice(0, -1) : element.orMarkup.slice(0, -1)) / 100))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      });
      priceListData.Datto.DattoSize.forEach(element => {
        var basePrice = (parseFloat(element.newBaseCost != '' ? element.newBaseCost.slice(1).replace(/  |,/gi,"") : element.defBaseCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(priceListData.Datto.newDevicePercent != '' ? priceListData.Datto.newDevicePercent.slice(0, -1) : priceListData.Datto.defDevicePercent.slice(0, -1)) / 100)))
        element.basePrice = '$' + basePrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        var monthlyPrice = (parseFloat(element.newMonthlyCost != '' ? element.newMonthlyCost.slice(1).replace(/  |,/gi,"") : element.defMonthlyCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(priceListData.Datto.newMonthlyPercent != '' ? priceListData.Datto.newMonthlyPercent.slice(0, -1) : priceListData.Datto.defMonthlyPercent.slice(0, -1)) / 100)))
        element.monthlyPrice = '$' + monthlyPrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      });
      this.priceListTableService.priceList.Datto.DattoSize = priceListData.Datto.DattoSize;
      this.priceListTableService.priceList.Intronis = priceListData.Intronis;
      if (this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyIncl == '1') {
        this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyMonthly = '$' + (parseFloat(priceListData.Backupify.Sell.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.Mailboxes)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.TotalBackUpTools();
        this.FeeSummaryMonthly();
      }
    } else {
      this.priceListTableService.priceList.TotalToolsMarkup = this.priceListTableService.priceList.defToolsMarkup;
      this.priceListTableService.priceList.TotalLabourRegularRate = this.priceListTableService.priceList.defLabourRegularRate;
      let sellVal = 1 + parseInt(this.priceListTableService.priceList.Backupify.OrPercent != '' ? this.priceListTableService.priceList.Backupify.OrPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100;
      this.priceListTableService.priceList.Backupify.Sell = '$' + (parseFloat(this.priceListTableService.priceList.Backupify.newCdnCost != '' ? this.priceListTableService.priceList.Backupify.newCdnCost.slice(1).replace(/  |,/gi,"") : this.priceListTableService.priceList.Backupify.defCdnCost.slice(1).replace(/  |,/gi,"")) * sellVal).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      this.priceListTableService.priceList.Intronis.forEach(element => {
        let cdn = (parseFloat(element.newUsd == '' ? element.defUsd.slice(1).replace(/  |,/gi,"") : element.newUsd.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.TotalUsExchange.slice(0, -1)) / 100)))
        element.cdn = '$' + cdn.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        element.monthlyPrice = '$' + (cdn * (1 + (parseFloat(element.orMarkup == '' ? this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1) : element.orMarkup.slice(0, -1)) / 100))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      });
      this.priceListTableService.priceList.Datto.DattoSize.forEach(element => {
        var basePrice = (parseFloat(element.newBaseCost != '' ? element.newBaseCost.slice(1).replace(/  |,/gi,"") : element.defBaseCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.Datto.newDevicePercent != '' ? this.priceListTableService.priceList.Datto.newDevicePercent.slice(0, -1) : this.priceListTableService.priceList.Datto.defDevicePercent.slice(0, -1)) / 100)))
        element.basePrice = '$' + basePrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        var monthlyPrice = (parseFloat(element.newMonthlyCost != '' ? element.newMonthlyCost.slice(1).replace(/  |,/gi,"") : element.defMonthlyCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.Datto.newMonthlyPercent != '' ? this.priceListTableService.priceList.Datto.newMonthlyPercent.slice(0, -1) : this.priceListTableService.priceList.Datto.defMonthlyPercent.slice(0, -1)) / 100)))
        element.monthlyPrice = '$' + monthlyPrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      });
    }
    this.bindHeaderValues();
}
  ngAfterViewInit(){
        document.getElementById('pageWidth').scrollIntoView();
  }
  ngAfterViewChecked() {
    localStorage.setItem('BACKUPDRsScreenData', JSON.stringify(this.dataService.ProposalTable.backupDrPricingSheet));
  }
  addDeviceData(){
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER', status: true, params: this.headerValues});
    if (localStorage.getItem('BackupDrSelectedDevices') != "undefined"  && localStorage.getItem('BackupDrSelectedDevices') != null) {
      var selectedDevice = localStorage.getItem('BackupDrSelectedDevices');
      this.SelectedDevices = JSON.parse(selectedDevice);
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.noOfIntronisDevices = this.SelectedDevices.intronisConnectedDevices.length;
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.noOfDattoDevices = this.SelectedDevices.dattoConnectedDevices.length;
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.dattoOneTime = this.SelectedDevices.dattoOneTime;
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisOneTime = this.SelectedDevices.intronisOneTime;
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.dattoMonthly = this.SelectedDevices.dattoMonthlyPrice;
      if (this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.noOfDattoDevices != DEFAULTVALUE) {
        this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.dattoIncl = '1';
      } else {
        this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.dattoIncl = '';
      }
      this.subTotalBackupDR();
      this.totalBackupDrToolSets();
    }
    if (localStorage.getItem('BackupDrAllDatto') != null && localStorage.getItem('BackupDrAllDatto') != "undefined") {
      var allDatto = localStorage.getItem('BackupDrAllDatto');
      var parseDatto = JSON.parse(allDatto);
      var dattoValue = '';
      var dattoDevices = '';
      parseDatto.forEach(element => {
        if (element.device != '') {
          if (element.updateOrNew.toUpperCase() == 'N') {
            dattoValue += element.device + ' @ ' + element.purchasePrice + ',';
          }
          if (element.updateOrNew.toUpperCase() == 'N' || element.updateOrNew.toUpperCase() == 'U') {
            dattoDevices += element.device + ', ';
          }
        }
      });
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.dattoDevicesAndPrice = 'Datto Device(s): ' + dattoValue;
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.dattoDevicesOnly = 'Datto Device(s): ' + dattoDevices;
    }
    if (localStorage.getItem('BackupDrAllIntronis') != null && localStorage.getItem('BackupDrAllIntronis') != "undefined") {
      var allIntronis = localStorage.getItem('BackupDrAllIntronis');
      var parseIntronis = JSON.parse(allIntronis);
      var intronisValue = '';
      var intronisDevices = '';
      parseIntronis.forEach(element => {
        if (element.device != '') {
          if (element.updateOrNew == '' || element.updateOrNew.toUpperCase() == 'N') {
            intronisValue += element.device + ' @ ' + element.purchasePrice + ',';
            intronisDevices += element.device + ', ';
          }
        }
      });
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisDevicesAndPrice = 'Intronis: ' + intronisValue;
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisDevicesOnly = 'Intronis: ' + intronisDevices;
    }
  }
  bindHeaderValues(){
    let obj = {
      "oneTime" : 'One time',
      "monthly" : 'Monthly',
      "monthlyValue": this.dataService.ProposalTable.backupDrPricingSheet.BackupFeesummaryTotaly,
      "OneTimeValue": this.dataService.ProposalTable.backupDrPricingSheet.totalBackupDrServiceOneTimeFees
    }
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: obj});
  }
  OnSetupConfigHours(event) {
    if (event.target.value != '') {
      let val = parseFloat(event.target.value) * parseFloat(this.priceListTableService.priceList.TotalLabourRegularRate.slice(1).replace(/  |,/gi,""));
        this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.SetupConfigOneTime = '$' + val.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else {
      this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.SetupConfigOneTime = '';
    }
    this.subTotalStartUpFees();
  }
  OnCourtesyDiscountHours(event) {
    if (event.target.value != '') {
      if (event.target.value.includes("$") == true) {
        let val = event.target.value.slice(1).replace(/  |,/gi,"");
        this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.CourtesyDiscountHours = '$' + parseFloat(val).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.CourtesyDiscountHours = '$'.concat(parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","));
      }
      this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.CourtesyDiscountOneTime = this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.CourtesyDiscountHours
    } else {
      this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.CourtesyDiscountHours = '';
      this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.CourtesyDiscountOneTime = '';
    }
    this.subTotalStartUpFees();
  }

  subTotalStartUpFees() {
    if (this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.SetupConfigOneTime != "") {
      var setupConfigTotal = parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.SetupConfigOneTime.slice(1).replace(/  |,/gi,""));
    } else {
      var setupConfigTotal = DEFAULTVALUE;
    }
    if (this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.CourtesyDiscountOneTime != '') {
      var CourtesyDiscountTotal = parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.CourtesyDiscountOneTime.slice(1).replace(/  |,/gi,""));
    } else {
      var CourtesyDiscountTotal = DEFAULTVALUE;
    }
    this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.subTotalStartUp = '$' + (setupConfigTotal - CourtesyDiscountTotal).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    this.TotalBackupDrServiceOneTime();
  }
  TotalBackupDrServiceOneTime() {
    if (this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.subTotalStartUp != undefined && this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.subTotalStartUp != '') {
      var subtTotal1 = parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.oneTimeFee.subTotalStartUp.slice(1).replace(/  |,/gi,""));
    } else {
      subtTotal1 = DEFAULTVALUE;
    }
    if (this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.TotalBackupDrOneTime != '') {
      var subtTotal2 = parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.TotalBackupDrOneTime.slice(1).replace(/  |,/gi,""));
    } else {
      subtTotal2 = DEFAULTVALUE;
    }
    let Total = (subtTotal1 + subtTotal2).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    if (Total == '0.00') {
      this.dataService.ProposalTable.backupDrPricingSheet.totalBackupDrServiceOneTimeFees = '';
    } else {
      this.dataService.ProposalTable.backupDrPricingSheet.totalBackupDrServiceOneTimeFees = '$' + Total;
    }
    this.bindHeaderValues();
  }
  backupProductDiscount(event) {
    if (event.target.value != '') {
      if (event.target.value.includes("$") == true) {
        var backupDiscount = parseFloat(event.target.value.slice(1).replace(/  |,/gi,""));
      } else {
        backupDiscount = parseFloat(event.target.value);
      }
      this.showMonth = true;
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTotalDiscount = '$' + backupDiscount.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else {
      this.showMonth = false;
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTotalDiscount = '';
    }
    this.TotalDiscountMonth();
    this.FeeSummaryMonthly();
  }

  FeeSummaryMonthly() {
    let val = (parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.backupTools.totalBackupDrMonthlyTool != '' ? this.dataService.ProposalTable.backupDrPricingSheet.backupTools.totalBackupDrMonthlyTool.slice(1).replace(/  |,/gi,"") : '0'));
    let subVal = (parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTotalDiscount != '' ? this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTotalDiscount.slice(1).replace(/  |,/gi,"") : '0'));
    let toatlVal = (val - subVal);
    if(toatlVal != DEFAULTVALUE){
      this.dataService.ProposalTable.backupDrPricingSheet.BackupFeesummaryTotaly = '$' + toatlVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.backupDrPricingSheet.BackupFeesummaryTotaly = '';
    }
    this.bindHeaderValues();
  }

  discountsForMonths(event) {
    var startMonth = this.months[this.DateDefault.getMonth()];
    var startYear = this.DateDefault.getYear().toString().slice(-2);
    var startDate = this.DateDefault.getDate().toString().padStart(2, '0');
    var newDate = new Date(this.DateDefault);
    var valArr = '';
    this.discountMonths.forEach(elem => {
      if (elem.period == event.target.value && elem.value != '') {
        valArr = elem.value;
      }
    })
    if (valArr != '') {
      newDate.setMonth(this.DateDefault.getMonth() + parseInt(valArr));
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.monthlyPeriod = this.months[newDate.getMonth()] + " 01 '" + newDate.getFullYear().toString().slice(-2) + ". Assumes start of " + startMonth + " " + startDate + " '" + startYear;
    } else {
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.monthlyPeriod = '';
    }
    this.TotalDiscountMonth();
  }
  TotalDiscountMonth() {
    this.dataService.ProposalTable.backupDrPricingSheet.DiscountMonth = 'Discount per Brian Everest ' + this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTotalDiscount + ' ' + this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdSelectedMonth + ' ' + this.dataService.ProposalTable.backupDrPricingSheet.backupTools.monthlyPeriod;
  }
  addRow(tableName) {
    if (tableName == 'OTHERBACKUPPRODUCTS') {
      let newObj = JSON.parse(this.newBackupProduct);
      newObj.backUpProdName = "pdt ".concat((this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable.length + 1).toString());
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable.push(newObj);
    }
  }
  sumofbackupProdPrice() {
    let sumArray = [];
    this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable.forEach(elem => {
      if (elem.price == '') {
        var totalval = DEFAULTVALUE
      } else {
        totalval = parseFloat(elem.price.slice(1).replace(/  |,/gi,""));
      }
      sumArray.push(totalval)
    })
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTotalPrice = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    this.totalBackupDrToolSets();
  }
  addDevices(event) {
    this.showAddDevice = true;
    setTimeout(() => {
      const componentFactory = this.resolver.resolveComponentFactory(AddDeviceComponent);
      this.viewContainerRef.clear();
      this.componentRef = this.viewContainerRef.createComponent(componentFactory);
      this.componentRef.instance.sheetId = 'BACKUPDRPRICINGSHEET'
      this.componentRef.instance.returnBack.subscribe(() => { this.cleadExcelComponent(); });
    }, 100);
  }
  cleadExcelComponent() {
    this.showAddDevice = false;
    this.addDeviceData();
  }
  intronisBackupDevice(event) {
    if (event.target.value == '1' && this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisDevicesOnly != '') {
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisIncl = event.target.value;
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisMonthly = this.SelectedDevices.intronisMonthlyPrice;
    } else if (event.target.value == '0') {
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisIncl = '';
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisMonthly = '';
    } else if (event.target.value == '') {
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisIncl = '';
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisMonthly = '';
    } else {
      let alert = this.alertCtrl.create({
        subTitle: '1 Include, 0 Exclude',
        buttons: ['ok']
      });
      alert.present();
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisIncl = ''
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisMonthly = '';
    }
    this.totalBackupDrToolSets();
  }
  backupifyBackupDevice(event) {
    if (event.target.value == '1') {
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyIncl = event.target.value;
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyMonthly = '$' + (parseFloat(this.priceListTableService.priceList.Backupify.Sell.slice(1).replace(/  |,/gi,"")) * parseInt(this.dataService.ProposalTable.mspForm.Mailboxes)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyDevicesOnly = 'Backupify:';
    } else if (event.target.value == '0') {
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyIncl = event.target.value;
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyMonthly = '';
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyDevicesOnly = '';
    } else if (event.target.value == '') {
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyIncl = '';
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyMonthly = '';
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyDevicesOnly = '';
    } else {
      let alert = this.alertCtrl.create({
        subTitle: '1 Include, 0 Exclude',
        buttons: ['ok']
      });
      alert.present();
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyIncl = '';
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyMonthly = '';
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyDevicesOnly = '';
    }
    this.totalBackupDrToolSets();
  }
  DeviceCourtesyDiscount(event) {
    let val = event.target.value.charAt(event.target.value.length - 1);
    if (event.target.value != '' && val != '%') {
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.deviceCourtesyDiscount = event.target.value.concat("%");
    } else {
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.deviceCourtesyDiscount = event.target.value;
    }
    this.subTotalBackupDR();
  }
  subTotalBackupDR() {
    if (this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.deviceCourtesyDiscount != '') {
      var discountVal = parseInt(this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.deviceCourtesyDiscount.slice(0, -1)) / 100;
    } else {
      discountVal = DEFAULTVALUE
    }
    let sumDevice = parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.dattoOneTime != '' ? this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.dattoOneTime.slice(1).replace(/  |,/gi,"") : '0') +
      parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisOneTime != '' ? this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisOneTime.slice(1).replace(/  |,/gi,"") : '0');
    this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.deviceCourtesyDiscountOneTime = discountVal == 0 ? '' : '$' + (sumDevice * discountVal).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    let TotalVal = (sumDevice - (sumDevice * discountVal)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    if (TotalVal == '0.00') {
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.TotalBackupDrOneTime = '';
    } else {
      this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.TotalBackupDrOneTime = '$' + TotalVal;
    }
    this.TotalBackupDrServiceOneTime();
  }
  backupProdQty(event, idx) {
    this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].quantity = event.target.value;
    if (event.target.value != '') {
      if (this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].price != '') {
        this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].monthly = '$' + (parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].quantity) * parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].price.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
    } else {
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].monthly = '';
    }
    this.TotalBackUpTools();
    this.totalBackupDrToolSets();
  }
  backupProdDescribe(event, idx) {
    this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].describe = event.target.value;
  }
  backupProdPrice(event, idx) {
    if (event.target.value != '') {
      if (event.target.value.includes("$") == true) {
        var price = parseFloat(event.target.value.slice(1).replace(/  |,/gi,""));
      } else {
        price = parseFloat(event.target.value);
      }
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].price = '$' + price.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      if (this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].quantity != '') {
        this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].monthly = '$' + (parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].quantity) * parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].price.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.TotalBackUpTools();
      }
      this.sumofbackupProdPrice();
    } else {
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].price = '';
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable[idx].monthly = '';
      this.sumofbackupProdPrice();
      this.TotalBackUpTools();
    }
  }
  TotalBackUpTools() {
    let sumArray = [];
    this.dataService.ProposalTable.backupDrPricingSheet.backupTools.backupProdTable.forEach(elem => {
      if (elem.monthly == '') {
        var totalval = DEFAULTVALUE
      } else {
        totalval = parseFloat(elem.monthly.slice(1).replace(/  |,/gi,""));
      }
      sumArray.push(totalval)
    })
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if (value == DEFAULTVALUE) {
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.totalBackupMonthlyPrice = '';
    } else {
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.totalBackupMonthlyPrice = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }
    this.totalBackupDrToolSets();
  }
  totalBackupDrToolSets() {
    let val = ((parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.backupTools.totalBackupMonthlyPrice != '' ? this.dataService.ProposalTable.backupDrPricingSheet.backupTools.totalBackupMonthlyPrice.slice(1).replace(/  |,/gi,"") : '0')
    + parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyMonthly != '' ? this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.backupifyMonthly.slice(1).replace(/  |,/gi,"") : '0')
    + parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisMonthly != '' ? this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.intronisMonthly.slice(1).replace(/  |,/gi,"") : '0')
    + parseFloat(this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.dattoMonthly != '' ? this.dataService.ProposalTable.backupDrPricingSheet.mspBackupDr.dattoMonthly.slice(1).replace(/  |,/gi,"") : '0')))
    if(val != DEFAULTVALUE){
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.totalBackupDrMonthlyTool = '$' + val.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.backupDrPricingSheet.backupTools.totalBackupDrMonthlyTool = '';
    }
    this.FeeSummaryMonthly();
  }
  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/components/backupdr-pricing-sheet/backupdr-pricing-sheet.ts